import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { eventCenter, event } from '@evideo/frontend-utils'
import {
  getOfficialTeacherCoursewareInfoByShareRecordId,
  getQGroupInfo,
  getQGroupSquareInfo
} from '@/services/audit-management'
import config from '@/config'
import PptEditor from '@/components/ppt-editor/PptEditor.vue'
import SheetSong from '@/components/common/SheetSong.vue'
import QGroup from '@/components/common/QGroup.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const recordId = route.params.recordId

const fileInfo = ref<any>({})

const pptEditor = ref()

const fileName = ref<string>('')

const url = ref(null)

const coursewareId = ref('')
const teacherQGroupId = ref()
const qGroupInfo = ref<any>()

const handleGoBack = () => {
  router.push('/resource/audit-management/official')
}

onBeforeRouteLeave((to, from, next) => {
  eventCenter.send(event.COMMON_UNLOAD_MICRO_APP, {
    app: config.pptist.name
  })
  setTimeout(() => {
    next()
  }, 0)
})

onMounted(async () => {
  const data = await getOfficialTeacherCoursewareInfoByShareRecordId((recordId as string))
  url.value = data.url || ''
  fileName.value = data.name
  fileInfo.value = data
  coursewareId.value = data.courseware_id
  if (fileInfo.value.type === 'qgroup') {
    if (data.extend_data?.official_qgroup_id) {
      teacherQGroupId.value = data.extend_data?.official_qgroup_id
      if (teacherQGroupId.value) {
        qGroupInfo.value = await getQGroupSquareInfo(teacherQGroupId.value)
      }
    } else if (data.extend_data?.teacher_qgroup_id) {
      teacherQGroupId.value = data.extend_data?.teacher_qgroup_id
      if (teacherQGroupId.value) {
        qGroupInfo.value = await getQGroupInfo(teacherQGroupId.value)
      }
    }
  }
})


return (_ctx: any,_cache: any) => {
  const _component_a_page_header = _resolveComponent("a-page-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_page_header, {
      subTitle: fileName.value,
      style: {"background-color":"white"},
      title: "预览课件"
    }, {
      extra: _withCtx(() => [
        _createElementVNode("a", { onClick: handleGoBack }, "返回")
      ]),
      _: 1
    }, 8, ["subTitle"]),
    (coursewareId.value&&fileInfo.value.type==='ppt')
      ? (_openBlock(), _createBlock(PptEditor, {
          key: 0,
          ref: (_value, _refs) => {
            _refs['pptEditor'] = _value
            pptEditor.value = _value
          },
          autoHideMenu: true,
          resource: url.value,
          height: "90vh",
          resourceType: "share",
          type: "preview",
          width: "100%"
        }, null, 8, ["resource"]))
      : _createCommentVNode("", true),
    (coursewareId.value&&fileInfo.value.type==='sheet_song')
      ? (_openBlock(), _createBlock(SheetSong, {
          key: 1,
          data: fileInfo.value.extend_data,
          style: {"width":"100%","height":"85vh","padding":"20px"}
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    (qGroupInfo.value?.questions&&fileInfo.value.type==='qgroup')
      ? (_openBlock(), _createBlock(QGroup, {
          key: 2,
          qgroupInfo: qGroupInfo.value
        }, null, 8, ["qgroupInfo"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})